export const SCHEDULES = '/scheduler/schedules'
export const UPDATE_SCHEDULE = '/scheduler/schedules/:scheduleId'
export const SCHEDULE_DETAILS = '/scheduler/schedules/:scheduleId/details'
export const SCHEDULE_RESULTS = '/scheduler/schedules/:scheduleId/results'
export const SCHEDULE_COLLECTIONS = '/scheduler/schedules/:scheduleId/collections'
export const AUTO_FIX_COLLECTION = '/scheduler/schedules/:scheduleId/collections/:collectionId/autofix'
export const GET_AND_SAVE_COLLECTION_PATH = '/scheduler/schedules/:scheduleId/collections/:collectionId'
export const GET_SCHEDULE_EXECUTION_LIST = '/scheduler/schedules/:scheduleId/executions'
export const SAVE_TO_SUMMARY = '/scheduler/schedules/:scheduleId/collections/:collectionId/save-to-summary'
